<template>
   <div class="banner-user" :style="{'background':'url('+userBackUrl+') center center', 'background-size':'1280px 100%','background-repeat': 'no-repeat'}">
		<div class="base-div clearfix">
			<div class="userinfo-avatar clearfix">
				<img :src="integralInfo.headPic!=''?integralInfo.headPic:require('../../assets/default_avatar.png')" />
				<div class="userinfo-avatar-r">
					<p class="userinfo-username">{{integralInfo.mail}}</p>
					<p class="userinfo-desc">{{integralInfo.nickName}}</p>
				</div>
			</div>
			<!-- <div class="banner-user-r clearfix">
				<span>积分</span>
				<span class="integral-num">{{integralInfo.integralNum}}</span>
				<img class="banner-logo" src="../../assets/banner_logo.png"/>
			</div> -->
		</div>
	</div>
</template>
<script>
export default {
    name: 'BannerUser',
	props: {
		integralInfo: {
			type: Object
		}
	},
	data(){
		return{
			userBackUrl: '',
			userBackUrlDefault: require('../../assets/userinfo_bg.png')
		}
	},
	created(){
		let activeInfo = localStorage.getItem('activeInfo')
		if(activeInfo!=null){
			activeInfo = JSON.parse(activeInfo)
			this.userBackUrl = activeInfo.userBackUrl?activeInfo.userBackUrl:require('@/assets/userinfo_bg.png')
			
		} else {
			this.getActiveInfo()
		}
	}
}
</script>
<style scoped>
.banner-user{height:133px; /*background:#e2ecf8*/ background:url(../../assets/userinfo_bg.png) no-repeat center center; background-size: 100% 100%}
.banner-user .base-div{padding-top: 25px}
.userinfo-avatar{float:left}
.userinfo-avatar img{float: left; width: 83px; height: 83px; margin-right: 35px;border-radius: 50%;}
.userinfo-avatar-r{float: left;}
.userinfo-desc{color:#797979}
.banner-user-r{float:right}
.banner-user-r span{float: left; color:#797979}
.banner-user-r span.integral-num{margin-left:10px; font-size: 56px; font-weight: bold; color:#DE0515}
.banner-logo{width:100px; height: 112px; margin-top: -13px}
</style>
